import { Dispatch } from "redux";
import { request } from "../util/request";
import { constantConfig, apiConfig } from 'web-common';
import { MenuItemVo } from "../config/menus";
import { ObjTest } from "../util/common";

const { GLOBAL_WEBSITE_URL } = apiConfig;

// 保存菜单
export const SAVE_MENU = 'SAVE_MENU';
// 更新当前是否为移动设备
export const UPDATE_IS_MOBILE = 'UPDATE_IS_MOBILE';



/**
 * 初始化菜单，获取动态子类菜单的children list
 * @returns 
 */
export const generateMenuList = () => (dispatch: Dispatch<any>, getState: any) => {
    const { menus } = getState().reducer || {};
    const tempMenus = menus.map(v => v);
    tempMenus.forEach((item: MenuItemVo) => {
        const { module, isAsyncChildrenMenu, children } = item;
        if (isAsyncChildrenMenu && !ObjTest.isNotEmptyArray(children)) {
            queryTreeNodeMenuList(module).then(res => {
                item.children = res.data || [];
            });
        }
    });
    dispatch(updateMenus(tempMenus));
};



/**
 * 查询树节点菜单，如果节点module类型是目录，则返回目录列表,如果节点module是内容，则返回内容列表
 * @param module
 */
export const queryTreeNodeMenuList = (module: constantConfig.ModuleTypeEnum) => {
    return request('/menu/list', { module }, { baseURL: GLOBAL_WEBSITE_URL, method: 'get' }).then(res => ({...res, module}));
};


/**
 * 更新或保存菜单
 * @param list 
 * @returns 
 */
export const updateMenus = (list: MenuItemVo[]) => {
    return { type: SAVE_MENU, payload: Array.isArray(list) ? list : [] };
};


/**
 * 根据menuId,查询内容列表
 * @param module
 * @param menuId 
 * @returns 
 */
export const queryMenuContentList = (module: constantConfig.ModuleTypeEnum, menuId?: string) => {
    let params = menuId ? { module, menuId } : { module };
    return request(
        '/content/list', 
        params, 
        { baseURL: GLOBAL_WEBSITE_URL, method: 'get' }
    ).then(res => ({...res, module}));
};


/**
 * 更新当前设备是否为移动设备
 * @param width 
 * @returns 
 */
export const updateIsMobile = (width: number) => {
    const flag = width <= 1024;
    return { type: UPDATE_IS_MOBILE, payload: flag };
};